import React, { Component } from 'react';
import CreatableSelect from 'react-select/creatable';
import voiceStore from '../stores/voiceStore';
import { observer } from 'mobx-react';
import { FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import projectStore from '../stores/projectStore';
import { Bars } from 'react-loader-spinner';

const withNavigation = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        return <WrappedComponent {...props} navigate={navigate} />;
    };
};

const AddTagsModal = observer(class AddTagsModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
        };
    }

    handleGenderSelect = (data) => {
        this.setState({ selectedGenders: data });
    };

    handleLanguageSelect = (data) => {
        this.setState({ selectedLanguages: data });
    };

    handleAccentSelect = (data) => {
        this.setState({ selectedAccents: data });
    };

    handleStyleSelect = (data) => {
        this.setState({ selectedStyles: data });
    };

    handleAgeGroupSelect = (data) => {
        this.setState({ selectedAgeGroups: data });
    };

    handleAdditionalTagsSelect = (data) => {
        this.setState({ selectedAdditionalTags: data });
    };

    handleSave = async () => {
        const { selectedGenders, selectedLanguages, selectedAccents, selectedAgeGroups, selectedStyles } = this.state;
        const payload = {
            ...(selectedGenders && selectedGenders.length > 0 && { gender: selectedGenders.map(gender => gender.value) }),
            ...(selectedLanguages && selectedLanguages.length > 0 && { language: selectedLanguages.map(language => language.value) }),
            ...(selectedAccents && selectedAccents.length > 0 && { accent: selectedAccents.map(accent => accent.value) }),
            ...(selectedAgeGroups && selectedAgeGroups.length > 0 && { age_group: selectedAgeGroups.map(ageGroup => ageGroup.value) }),
            ...(selectedStyles && selectedStyles.length > 0 && { style: selectedStyles.map(style => style.value) }),
        }

        if (JSON.stringify(payload) !== "{}") {
            this.setState({ loading: true });
            const result = await projectStore.addTags({ taglist: payload, operation: 'insert' });

            if (result) {
                this.setState({
                    selectedGenders: [],
                    selectedLanguages: [],
                    selectedAccents: [],
                    selectedAgeGroups: [],
                    selectedStyles: [],
                });
                voiceStore.getDropdownData();

                projectStore.setAddTagsModalVisible(false);
                this.setState({ loading: false });
            } else {
                this.setState({ loading: false });

                console.error('Error =>', result);
            }
        }
    };

    handleOverlayClick = (event) => {
        if (event.target === event.currentTarget) {
            projectStore.setAddTagsModalVisible(false);
        }
    };

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            projectStore.setAddTagsModalVisible(false);
        }
    };

    render() {

        const { accentOptions, ageGroupOptions, genderOptions, languageOptions, styleOptions } = voiceStore.normalDropdownData
        const { loading } = this.state
        return (
            <div onClick={this.handleOverlayClick} className="fixed inset-0 flex flex-1 w-full items-center overflow-y-scroll lg:overflow-hidden justify-center bg-black bg-opacity-50 z-[55]">
                <div className="lg:fixed h-auto flex flex-col w-full lg:w-[80%] bg-white p-6 rounded-lg shadow-lg pt-24 lg:pt-0">
                    <h2 className="font-bold text-3xl text-[#21272A] mb-4 pt-6">{`Add New Tags`}</h2>
                    <span className="font-normal text-sm text-[#21272A]">Click on the field you want to add tag, start typing, then create and save</span>
                    <FaTimes onClick={() => {
                        projectStore.setAddTagsModalVisible(false);
                    }} className='absolute right-5 top-5 hover:cursor-pointer' size={20} color='black'></FaTimes>
                    <div className="flex lg:flex-1 flex-col lg:flex-row w-full gap-3 mt-14">
                        <div className="flex flex-col lg:flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Gender</span>
                            <div>
                                <CreatableSelect
                                    placeholder="Enter Gender..."
                                    value={this.state.selectedGenders}
                                    onChange={this.handleGenderSelect}
                                    options={genderOptions}
                                    isSearchable={true}
                                    isMulti
                                    isOptionDisabled={(option) => genderOptions.includes(option)}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),

                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Language</span>
                            <div>
                                <CreatableSelect
                                    options={languageOptions}
                                    value={this.state.selectedLanguages}
                                    onChange={this.handleLanguageSelect}
                                    isSearchable={true}
                                    isMulti
                                    isOptionDisabled={(option) => languageOptions.includes(option)}
                                    placeholder="Enter Language..."
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Accent</span>
                            <div>
                                <CreatableSelect
                                    options={accentOptions}
                                    value={this.state.selectedAccents}
                                    onChange={this.handleAccentSelect}
                                    isSearchable={true}
                                    isMulti
                                    isOptionDisabled={(option) => accentOptions.includes(option)}
                                    placeholder="Enter Accent..."
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Age</span>
                            <div>
                                <CreatableSelect
                                    options={ageGroupOptions}
                                    value={this.state.selectedAgeGroups}
                                    onChange={this.handleAgeGroupSelect}
                                    isSearchable={true}
                                    isMulti
                                    isOptionDisabled={(option) => ageGroupOptions.includes(option)}
                                    placeholder="Enter Age Group..."
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col flex-1">
                            <span className="font-semibold text-base text-[#21272A] mb-2">Style</span>
                            <div>
                                <CreatableSelect
                                    options={styleOptions}
                                    value={this.state.selectedStyles}
                                    onChange={this.handleStyleSelect}
                                    isSearchable={true}
                                    isMulti
                                    isOptionDisabled={(option) => styleOptions.includes(option)}
                                    placeholder="Enter Style..."
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#F0EFEF',
                                            color: '#FFF',
                                            paddingTop: 5,
                                            paddingBottom: 5,
                                            boxShadow: 'none',
                                            border: '1px solid #ccc',
                                            '&:hover': {
                                                border: '1px solid #ccc'
                                            }
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            display: 'none'
                                        }),
                                        multiValue: (provided) => ({
                                            ...provided,
                                            backgroundColor: '#B7B7B7',
                                            borderRadius: 6
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            paddingRight: 10,
                                            paddingLeft: 16,
                                            paddingTop: 10,
                                            paddingBottom: 10
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#130D0D',
                                            ':hover': {
                                                backgroundColor: '#B7B7B7',
                                                color: '#130D0D',
                                                borderRadius: 6
                                            }
                                        })
                                    }}
                                />

                            </div>
                        </div>

                    </div>

                    <div className="mt-24 flex justify-end gap-2">
                        <button
                            className="text-white font-medium text-base px-6 py-2 rounded-md bg-[#130D0D]"
                            onClick={this.handleSave}
                        >
                            {!loading && 'Save'}
                            <Bars
                                height="25"
                                width="25"
                                color="#F89A1F"
                                ariaLabel="bars-loading"
                                visible={loading}
                            />
                        </button>
                    </div>
                </div>
            </div>
        );
    }
})

export default withNavigation(AddTagsModal);
